module.exports = __webpack_public_path__ + "assets/fonts/Gotham-BookItalic.a9558317.otf";